import { render, staticRenderFns } from "./GamesBetInfo.vue?vue&type=template&id=7082569c&scoped=true"
import script from "./GamesBetInfo.vue?vue&type=script&lang=js"
export * from "./GamesBetInfo.vue?vue&type=script&lang=js"
import style0 from "./GamesBetInfo.vue?vue&type=style&index=0&id=7082569c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7082569c",
  null
  
)

export default component.exports